<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      宝安站<br>
站点介绍<br>
宝安站位于宝安创业一路与裕安一路交叉口处，主体沿创业一路呈东西走向布置<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:03	00:11	11号线	4分钟	6分32秒<br>
碧头	06:23	23:56	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:03	00:11	11号线	4分34秒	6分钟<br>
碧头	06:23	23:56	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:03	00:11	11号线	4分37秒	6分钟<br>
碧头	06:23	23:56	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
宝源南路南侧（西）、裕安一路（西）、新安中学高中部、第五大道高发西岸花园、深业新岸线<br><br>
B出入口:<br>
宝源南路南侧（东）、裕安一路南侧、创业一路、前海人寿金融中心、深圳农商银行<br><br>
C出入口:<br>
宝源南路北侧（东）、裕安一路（东）、宝安区人民政府、壹方城购物中心<br><br>
D出入口:<br>
宝源南路北侧（西）、裕安一路北侧、宝安体育场、宝安区青少年业余体育学校、福中福幸福海岸<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 坳背市场<br>
930<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>